/**
 * @license
 * Copyright Stbui All Rights Reserved.
 * https://github.com/stbui
 */

import {
  Component,
  Directive,
  ContentChildren,
  QueryList,
  AfterContentInit
} from '@angular/core';

@Directive({ selector: 'app-dialog-title' })
export class DialogTitleDirective {}

@Directive({ selector: 'app-dialog-content' })
export class DialogContentDirective {}

@Directive({ selector: 'app-dialog-actions' })
export class DialogActionsDirective {}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements AfterContentInit {
  @ContentChildren(DialogTitleDirective)
  dialogTitle: QueryList<DialogTitleDirective>;
  @ContentChildren(DialogContentDirective)
  dialogContent: QueryList<DialogContentDirective>;
  @ContentChildren(DialogActionsDirective)
  dialogActions: QueryList<DialogActionsDirective>;

  ngAfterContentInit(): void {
    if (this.dialogTitle.length > 1) {
      throw new Error(
        'Duplicate app-dialog-title component at in app-dialog.'
      );
    }
    if (this.dialogContent.length > 1) {
      throw new Error(
        'Duplicate app-dialog-content component at in app-dialog.'
      );
    }
    if (this.dialogActions.length > 1) {
      throw new Error(
        'Duplicate app-dialog-actions component at in app-dialog.'
      );
    }
  }
}
